import { Modal, Button, notification } from 'antd'
import axios, { all } from 'axios'
import React, { useState } from 'react'
import baseUrl, { betaBaseUrl } from '../../config';
import { CheckCircleTwoTone, SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const AddPanelCode = ({
    modalOpen2,
    setModalOpen2,
    refresh,
    setRefresh,
    selectedRow,
    isBeta
}) => {
    const { t } = useTranslation();
    const [allData, setAllData] = useState({
        number: "",
    })

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('constraint.systemInfo'),
            description: `${value}`,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
    };

    const handleChange = (e) => {
        setAllData({ ...allData, [e.target.name]: e.target.value });
    }


    const possibleValues = ["rearPanel", "kapiIcSac", "topBottom", "sidePanel", "backPanel"]
    const selectedPanelKey = possibleValues.find(value => selectedRow[value]);
    const selectedPanelValue = selectedRow[selectedPanelKey];

    const handleSubmit = (e) => {
        e.preventDefault()
        // API endpoint'ini ortama göre ayarla
        const apiEndpoint = isBeta ? `${betaBaseUrl}/addKisit` : `${baseUrl}/addKisit`;
        
        axios.post(apiEndpoint, ({ number: allData.number, panel: selectedPanelValue }))
            .then(res => {
                if (res.status === 200) {
                    setModalOpen2(false)
                    openNotification('top', 'Gönderildi')
                    setAllData({
                        number: "",
                    })
                    setRefresh(!refresh)
                }
                if (res.status === 201) {
                    openNotification('top', res.data, <WarningTwoTone twoToneColor="red" />)
                }
            });
    }

    return (
        <>
            {contextHolder}
            <Modal
                title={`${t('constraint.addPanel')} ${isBeta ? '(Beta)' : ''}`}
                centered
                open={modalOpen2}
                onCancel={() => {
                    setAllData({
                        number: "",
                    })
                    setModalOpen2(false)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <form onSubmit={handleSubmit}>
                    <div className='w-full flex flex-col gap-10 justify-center mt-8'>
                        <div className='flex'>
                            <label className='flex w-32 mt-1'>{t('constraint.panelCode')} : </label>
                            <input required type='number' onChange={handleChange} name="number" placeholder={t('constraint.enterPanelCode')} value={allData.number} className='border border-solid border-borderColor rounded-lg  h-33px w-full' />
                        </div>
                        <div className='w-full flex flex-col gap-3 justify-center mt-8'>
                            <Button type='submit' htmlType='submit' className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base '>{t('constraint.submit')}</Button>
                        </div>
                    </div>
                </form>
            </Modal>
        </>
    )
}

export default AddPanelCode